const t = {
  "cdr-text": "cdr-text_15-0-1"
};
export {
  t as default
};
